import { Component, OnInit } from '@angular/core';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-url-cell',
    templateUrl: './url-cell.component.html',
    styleUrls: ['./url-cell.component.scss'],
    standalone: false
})
export class UrlCellComponent implements OnInit {
  url: any;
  name: string;

  constructor() {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    const value = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    if (!value) {
      this.url = null;
      this.name = null;
      return;
    }

    const linkMarkdownFormat = /^\[(?<name>.*)\]\((?<url>.*)\)$/gm;
    const match = linkMarkdownFormat.exec(value);
    this.name = match?.groups?.name;
    let url = match?.groups?.url;

    if (!url) {
      url = value;
    }

    url = url.replace(/^http:\/\//i, 'https://');
    if (!url.startsWith('https://')) {
      url = `https://${url}`;
    }
    this.url = url;

    if (!this.name) {
      this.name = url;
    }

    this.url = url;
  }
}
